

const sortByTier = (
  teamsOrOrgs
) => {
  const teamsSlice = teamsOrOrgs.slice()
  const tierVal = (team) => (team.tier === 'enterprise' ? -2 : team.tier === 'team' ? -1 : 1)
  teamsSlice.sort((a, b) =>
    tierVal(a) < tierVal(b)
      ? -1
      : tierVal(a) > tierVal(b)
      ? 1
      : a.name.toLowerCase() < b.name.toLowerCase()
      ? -1
      : 1
  )
  return teamsSlice 
}

export default sortByTier
